import { Injectable, inject } from '@angular/core';
import { ApiClient } from '../api/api-client';
import { LocalStorageService } from '../storage/local-storage.service';
import { catchError, Observable, of, tap } from 'rxjs';
import { ApiResponse } from '../models/api/api-response.model';
import { LoginRequest, LoginResponse } from '../models/auth/login.model';
import { isTokenValid } from '../utils/token.util';
import { Router } from '@angular/router';
import { ROUTE_PATHS } from '../constants/routes.constants';


@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly api = inject(ApiClient);
  private readonly storage = inject(LocalStorageService);
  private readonly router = inject(Router);

    login(credentials: LoginRequest): Observable<ApiResponse<LoginResponse>> {
        return this.api.post<ApiResponse<LoginResponse>>('auth/user/login', credentials).pipe(
            tap(response => {
                this.storage.setAccessToken(response.result.token);
                this.storage.setRefreshToken(response.result.tokenRefresh);
                this.storage.setUser(response.result);
            })
        );
    }

    refreshToken(token: string): Observable<ApiResponse<LoginResponse>> {
        return this.api
            .post<ApiResponse<LoginResponse>>('auth/refresh-token', { refreshToken: token })
            .pipe(
            tap(response => {
                const result = response.result;
                this.storage.setAccessToken(result.token);
                this.storage.setRefreshToken(result.tokenRefresh);
                this.storage.setUser(response.result);
            })
        );
    }





    logout(): void {
        this.storage.clearSession();
        this.router.navigateByUrl(ROUTE_PATHS.AUTH_LOGIN);
    }

    getAccessToken(): string | null {
        return this.storage.getAccessToken();
    }

    getRefreshToken(): string | null {
        return this.storage.getRefreshToken();
    }

    getCurrentUser() {
        return this.storage.getUser();
    }

    isLoggedIn(): boolean {
        const accessToken = this.getAccessToken();
        const refreshToken = this.getRefreshToken();

        // No hay tokens → no hay sesión activa
        if (!accessToken && !refreshToken) return false;

        // Token de acceso válido → sesión activa
        if (isTokenValid(accessToken)) return true;

        // Access token expirado pero hay refresh token → sesión renovable
        return !!refreshToken;
    }

}
